import React, { useState } from "react";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import { Table } from "antd";
import { useHistory } from "react-router-dom";
import moment from "moment";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
export const DebtList = ({ liabilitiesCredit, loading, amortizationData }) => {
  const history = useHistory();
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const fnView = (record) => {
    history.push(`/debt-payOff/debt-details/${record.subType}/${record.id}`);
  };
  console.log(
    "amortizationDataNewww",
    amortizationData && amortizationData.moduleAmortizationData
  );
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };

  const debt_cols = [
    {
      title: "Name of Liability",
      dataIndex: "Nickname of Liabilities",
      sorter: (a, b) => {
        const nameA = a["Nickname of Liabilities"].toLowerCase() || "";
        const nameB = b["Nickname of Liabilities"].toLowerCase() || "";
        return nameA.localeCompare(nameB); // Proper string sorting
      },
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <img
            src={record.image}
            width={32}
            height={32}
            alt={record["Nickname of Liabilities"]}
          />
          <div className="asset-name">{text || "N/A"}</div>
        </div>
      ),
    },
    {
      title: "Balance",
      dataIndex: "Loan Balance",
      sorter: (a, b) => {
        const getValue = (row) => {
          if (row.subType === "Credit") {
            return parseFloat(
              row["Credit Balance"] || row["Loan Balance"] || 0
            );
          }
          return parseFloat(
            row["Loan Balance"] || row["Initial Loan Amount"] || 0
          );
        };

        return getValue(a) - getValue(b);
      },
      render: (record, row) => {
        let value;
        if (row.subType === "Credit") {
          value = row["Credit Balance"] || row["Loan Balance"] || 0;
        } else {
          value = row["Loan Balance"] || row["Initial Loan Amount"] || 0;
        }

        return value
          ? !isNaN(value)
            ? `$${parseFloat(value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
            : "N/A"
          : "N/A";
      },
    },
    // {
    //   title: "Balance",
    //   dataIndex: "Loan Balance",
    //   sorter: (a, b) => {
    //     const getBalance = (record) => {
    //       const nickname = record["Nickname of Liabilities"];
    //       const currentMonth = moment().format("MM-DD-YYYY");

    //       const liabilityData =
    //         amortizationData &&
    //         amortizationData.moduleAmortizationData &&
    //         amortizationData.moduleAmortizationData.find(
    //           (item) => item.nickname === nickname
    //         );

    //       if (!liabilityData || !liabilityData.formattedLiabilityData) return 0;

    //       const monthData = liabilityData.formattedLiabilityData.find((obj) =>
    //         moment(obj.date, "MM-DD-YYYY").isSame(
    //           moment(currentMonth, "MM-DD-YYYY"),
    //           "month"
    //         )
    //       );

    //       return monthData && monthData.balance
    //         ? parseFloat(monthData.balance)
    //         : 0;
    //     };

    //     return getBalance(a) - getBalance(b);
    //   },
    //   render: (text, record) => {
    //     const nickname = record["Nickname of Liabilities"];
    //     const currentMonth = moment().format("MM-DD-YYYY");

    //     // Find matching liability data by nickname
    //     const liabilityData =
    //       amortizationData &&
    //       amortizationData.moduleAmortizationData &&
    //       amortizationData.moduleAmortizationData.find(
    //         (item) => item.nickname === nickname
    //       );

    //     if (!liabilityData || !liabilityData.formattedLiabilityData)
    //       return "N/A";

    //     // Find the object for current month
    //     const monthData = liabilityData.formattedLiabilityData.find((obj) =>
    //       moment(obj.date, "MM-DD-YYYY").isSame(
    //         moment(currentMonth, "MM-DD-YYYY"),
    //         "month"
    //       )
    //     );
    //     console.log("monthdatata", liabilityData, nickname);
    //     // If current month not found, fallback to the latest balance
    //     const balance = (monthData && monthData.balance) || 0;

    //     return balance !== undefined
    //       ? `$${parseFloat(balance)
    //           .toFixed(2)
    //           .toString()
    //           .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
    //       : "N/A";
    //   },
    // },
    {
      title: "Interest Rate(%APR)",
      dataIndex: "Interest Rate",
      sorter: (a, b) => {
        const rateA = a["Interest Rate"] ? parseFloat(a["Interest Rate"]) : 0;
        const rateB = b["Interest Rate"] ? parseFloat(b["Interest Rate"]) : 0;
        return rateA - rateB;
      },
      render: (record) =>
        record ? `${parseFloat(record).toFixed(2) + "%"} ` : "N/A",
    },
    {
      title: "Mos. to Payoff",
      dataIndex: "Maturity Date",
      sorter: (a, b) => {
        const endA =
          amortizationData &&
          amortizationData.creditEndDates.find(
            (c) => c.nickname === a["Nickname of Liabilities"]
          );
        const endB =
          amortizationData &&
          amortizationData.creditEndDates.find(
            (c) => c.nickname === b["Nickname of Liabilities"]
          );
        return (
          (endA && endA.endingMonth
            ? moment(endA.endingMonth, "MM-DD-YYYY").valueOf()
            : 0) -
          (endB && endB.endingMonth
            ? moment(endB.endingMonth, "MM-DD-YYYY").valueOf()
            : 0)
        );
      },
      render: (text, record) => {
        const nickname = record["Nickname of Liabilities"];
        const creditEndDate =
          amortizationData &&
          amortizationData.creditEndDates.find((c) => c.nickname === nickname);

        if (creditEndDate && !creditEndDate.endingMonth) return "N/A";

        const currentMonth = moment();
        const payoffMonth =
          creditEndDate && moment(creditEndDate.endingMonth, "MM-DD-YYYY");

        const monthsToPayoff =
          payoffMonth && payoffMonth.diff(currentMonth, "months");
        return monthsToPayoff >= 0 ? monthsToPayoff : 0;
      },
    },
    {
      title: "Date Paid Off",
      dataIndex: "Maturity Date",
      sorter: (a, b) => {
        const endA =
          amortizationData &&
          amortizationData.creditEndDates.find(
            (c) => c.nickname === a["Nickname of Liabilities"]
          );
        const endB =
          amortizationData &&
          amortizationData.creditEndDates.find(
            (c) => c.nickname === b["Nickname of Liabilities"]
          );
        return (
          (endA && endA.endingMonth
            ? moment(endA.endingMonth, "MM-DD-YYYY").valueOf()
            : 0) -
          (endB && endB.endingMonth
            ? moment(endB.endingMonth, "MM-DD-YYYY").valueOf()
            : 0)
        );
      },
      render: (text, record) => {
        const nickname = record["Nickname of Liabilities"];
        const creditEndDate =
          amortizationData &&
          amortizationData.creditEndDates.find((c) => c.nickname === nickname);

        if (creditEndDate && !creditEndDate.endingMonth) return "N/A";

        const payoffMonth =
          creditEndDate && moment(creditEndDate.endingMonth, "MM-DD-YYYY");

        return creditEndDate ? creditEndDate.endingMonth : "N/A";
      },
    },
    // {
    //   title: "Monthly Payment",
    //   dataIndex: "Monthly Payment",
    //   render: (record) =>
    //     record
    //       ? !isNaN(record)
    //         ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
    //           `$${parseFloat(record)
    //             .toFixed(2)
    //             .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
    //         : "N/A"
    //       : "N/A",
    // },

    {
      title: "Total Interest",
      dataIndex: "Interest Rate",
      sorter: (a, b) => {
        let interestA = 0;
        let interestB = 0;

        if (
          amortizationData &&
          amortizationData.moduleAmortizationData &&
          amortizationData.moduleAmortizationData.length
        ) {
          const liabilityA = amortizationData.moduleAmortizationData.find(
            (item) => item.nickname === a["Nickname of Liabilities"]
          );
          const liabilityB = amortizationData.moduleAmortizationData.find(
            (item) => item.nickname === b["Nickname of Liabilities"]
          );

          if (
            liabilityA &&
            liabilityA.formattedLiabilityData &&
            liabilityA.formattedLiabilityData.length
          ) {
            interestA =
              liabilityA.formattedLiabilityData[
                liabilityA.formattedLiabilityData.length - 1
              ].cumulativeInterest || 0;
          }

          if (
            liabilityB &&
            liabilityB.formattedLiabilityData &&
            liabilityB.formattedLiabilityData.length
          ) {
            interestB =
              liabilityB.formattedLiabilityData[
                liabilityB.formattedLiabilityData.length - 1
              ].cumulativeInterest || 0;
          }
        }

        return interestA - interestB;
      },
      render: (text, record) => {
        const nickname = record["Nickname of Liabilities"];

        // Find matching liability data by nickname
        const liabilityData =
          amortizationData &&
          amortizationData.moduleAmortizationData &&
          amortizationData.moduleAmortizationData.find(
            (item) => item.nickname === nickname
          );

        if (!liabilityData || !liabilityData.formattedLiabilityData)
          return "N/A";
        // If current month not found, fallback to the latest balance
        const interestPaidData =
          liabilityData &&
          liabilityData.formattedLiabilityData &&
          liabilityData.formattedLiabilityData[
            liabilityData.formattedLiabilityData.length - 1
          ];
        const interestPaid =
          (interestPaidData && interestPaidData.cumulativeInterest) || 0;

        return interestPaid !== undefined
          ? `$${parseFloat(interestPaid)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : "N/A";
      },
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
          </div>
        );
      },
    },
  ];

  return (
    <div style={{ marginTop: "1rem", position: "relative" }}>
      {" "}
      <div className="incomeInfoMaincard">
        <h3 className="incomecardheading">Debt List</h3>
        {/*<List cols={report_cols} rows={data} /> */}
        <Table
          columns={debt_cols}
          dataSource={liabilitiesCredit && liabilitiesCredit}
          //   pagination={{
          //     total: totalPages * 10, // Assuming 10 items per page
          //     current: page,
          //     onChange: (page) => {
          //       setCurrentPage(page);
          //     },
          //     pageSize: 10, // Number of items per page
          //   }}
        />
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
